// Preview-only mirror of the backend's installment rounding logic
// (kbt-backend quickBooks/paymentPlanAllocation.js). Used to show the
// member a live estimate before they submit; the backend independently
// computes and enforces the authoritative amount, so this file never needs
// to be perfectly in sync — it only needs to be a reasonable preview.
//
// Amounts here are dollars (not cents) to match how the rest of the
// member-facing UI formats currency (see MyAccount.js `currency()`).

export const MIN_INSTALLMENTS = 2;
export const MAX_INSTALLMENTS = 12;
const MIN_INSTALLMENT_AMOUNT = 1;

// Returns { installmentAmount, totalCharged, roundingDifference } or null
// if the inputs are out of range (the caller should disable submission
// rather than show an error for a preview).
export const computeInstallmentPreview = (totalAmount, installments) => {
  if (!Number.isFinite(totalAmount) || totalAmount <= 0) return null;
  if (
    !Number.isInteger(installments) ||
    installments < MIN_INSTALLMENTS ||
    installments > MAX_INSTALLMENTS
  ) {
    return null;
  }

  const installmentAmount = Math.round((totalAmount / installments) * 100) / 100;
  if (installmentAmount < MIN_INSTALLMENT_AMOUNT) return null;

  const totalCharged = Math.round(installmentAmount * installments * 100) / 100;
  const roundingDifference = Math.round((totalCharged - totalAmount) * 100) / 100;

  return { installmentAmount, totalCharged, roundingDifference };
};
